var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.context.classes.element,
      attrs: { "data-type": _vm.context.type, "data-has-files": _vm.hasFiles }
    },
    [
      _c(
        "FormulateSlot",
        { attrs: { name: "prefix", context: _vm.context } },
        [
          _vm.context.slotComponents.prefix
            ? _c(_vm.context.slotComponents.prefix, {
                tag: "component",
                attrs: { context: _vm.context }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.context.classes.uploadArea,
          attrs: { "data-has-files": _vm.hasFiles }
        },
        [
          _c(
            "input",
            _vm._g(
              _vm._b(
                {
                  ref: "file",
                  attrs: { "data-is-drag-hover": _vm.isOver, type: "file" },
                  on: {
                    blur: _vm.context.blurHandler,
                    change: _vm.handleFile,
                    dragover: _vm.handleDragOver,
                    dragleave: _vm.handleDragLeave
                  }
                },
                "input",
                _vm.attributes,
                false
              ),
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "FormulateSlot",
            {
              attrs: {
                name: "uploadAreaMask",
                context: _vm.context,
                "has-files": _vm.hasFiles
              }
            },
            [
              _c(_vm.context.slotComponents.uploadAreaMask, {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.hasFiles,
                    expression: "!hasFiles"
                  }
                ],
                tag: "component",
                class: _vm.context.classes.uploadAreaMask,
                attrs: {
                  "has-files":
                    _vm.context.slotComponents.uploadAreaMask === "div"
                      ? false
                      : _vm.hasFiles,
                  "data-has-files":
                    _vm.context.slotComponents.uploadAreaMask === "div"
                      ? _vm.hasFiles
                      : false
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasFiles
            ? _c("FormulateFiles", {
                attrs: {
                  files: _vm.context.model,
                  "image-preview":
                    _vm.context.type === "image" &&
                    _vm.context.imageBehavior === "preview",
                  context: _vm.context
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "FormulateSlot",
        { attrs: { name: "suffix", context: _vm.context } },
        [
          _vm.context.slotComponents.suffix
            ? _c(_vm.context.slotComponents.suffix, {
                tag: "component",
                attrs: { context: _vm.context }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }